import { find } from "lodash";
import React, { useMemo } from "react";
import { useMembers } from "../../../context/members";
import MemberAvatarImg from "../../../context/members/MemberAvatarImg";
import classNames from "../../../utils/classNames";

interface Props {
  className?: string;
  memberUuid: string | null;
  subtitle?: string;
}

const MemberCell: React.FC<Props> = ({ className, memberUuid, subtitle }) => {
  const { members } = useMembers();

  const member = useMemo(
    () => find(members, { uuid: memberUuid }),
    [memberUuid, members]
  );

  if (!member) return null;

  return (
    <div
      className={classNames(
        "relative flex items-center space-x-3 text-sm font-medium text-gray-900 dark:text-white",
        className
      )}
    >
      <div className="flex-shrink-0">
        <MemberAvatarImg member={member} sizeInPx={40} />
      </div>
      <div className="flex-1 min-w-0 focus:outline-none">
        <p className="text-sm font-medium text-gray-900 truncate dark:text-white">
          {member.name || member.email}
        </p>
        {subtitle && (
          <p className="text-sm font-normal text-gray-500 truncate dark:text-gray-400">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default MemberCell;
